import React from 'react';
import '../styles/tools.css';

// Replace these paths with your actual image files placed in src/assets/tools/
import wordpress from '../assets/tools/wordpress-color.svg';
import joomla from '../assets/tools/joomla-logo-icon.webp';
import drupal from '../assets/tools/drupal-logo-icon.webp';
import perl from '../assets/tools/perl-logo-icon.webp';
import php from '../assets/tools/php-logo-icon.webp';
import mysql from '../assets/tools/mysql-logo-icon.svg';
import apache from '../assets/tools/apache-logo-icon.svg';
import rails from '../assets/tools/ruby-logo-icon.webp';

const tools = [
  {
    name: 'WordPress',
    img: wordpress,
    desc: 'WordPress is web software used to create a beautiful website or blog.'
  },
  {
    name: 'Joomla',
    img: joomla,
    desc: 'Joomla is one of the world’s most popular open source CMS.'
  },
  {
    name: 'Drupal',
    img: drupal,
    desc: 'Drupal is an open source CMS platform powering millions of websites.'
  },
  {
    name: 'Perl',
    img: perl,
    desc: 'Perl 5 is a highly capable, feature-rich programming language.'
  },
  {
    name: 'PHP',
    img: php,
    desc: 'PHP is a widely used general-purpose scripting language for programmers.'
  },
  {
    name: 'MySQL',
    img: mysql,
    desc: 'MySQL is the world’s most popular open source database platform.'
  },
  {
    name: 'Apache',
    img: apache,
    desc: 'Apache is the world’s most prominent open source web server software.'
  },
  {
    name: 'Ruby on Rails',
    img: rails,
    desc: 'Ruby on Rails is an open source framework optimized for programmers.'
  }
];

const ToolsSection = () => {
  return (
    <section className="tools-wrapper">
      <h2 className="tools-title">Free, Powerful Tools to Make Learning a Breeze</h2>
      <div className="tools-grid">
        {tools.map((tool, index) => (
          <div className="tool-card" key={index}>
            <img src={tool.img} alt={tool.name} className="tool-logo" />
            <p className="tool-desc">{tool.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ToolsSection;
